import {
    GuiaActionTypes,
    RESET_GUIA_NUEVA,
    SET_GUIA_DESTINO,
    SET_GUIA_ORIGEN,
    SET_GUIA_WIZARD,
    SET_GUIA_MERCANCIAS,
    SET_GUIA_MERCANCIAS_COMPLEMENTARIAS,
    SET_GUIA_SERVICIOS,
    SET_GUIA_CONSULTA,
    CLEAR_GUIA_CONSULTA
} from "../types/guiaActionTypes";
import { IRecoleccion } from "../types/recoleccionActionTypes";
import { initialRecoleccionState } from "./recoleccionReducer";
import { IGuiaWizard, initialGuiaWizard } from "../../entities/guias/IGuiaWizard";
import { Mercancia } from "../../entities/solicitudes/Mercancia";
import { initialMercancia } from "./mercanciaReducer";
import { ServicioAdicional } from "../../entities/catalogos/ServicioAdicional";
import { MercanciaDatosComplementarios } from "../../entities/solicitudes/MercanciaDatosComplementarios";
import { IGuiaConsultaDto } from "../../entities/guias/IGuiaConsultaDto";

export function guiaWizardReducer(state = initialGuiaWizard, action: GuiaActionTypes): IGuiaWizard {
    switch (action.type) {
        case SET_GUIA_WIZARD:
            return action.wizard;
        case RESET_GUIA_NUEVA:
            return { ...initialGuiaWizard };
        default:
            return state;
    }
}

export function guiaOrigenReducer(state = initialRecoleccionState, action: GuiaActionTypes): IRecoleccion {
    switch (action.type) {
        case SET_GUIA_ORIGEN:
            return action.recoleccion;
        case RESET_GUIA_NUEVA:
            return { ...initialRecoleccionState };
        default:
            return state;
    }
}

export function guiaDestinoReducer(state = initialRecoleccionState, action: GuiaActionTypes): IRecoleccion {
    switch (action.type) {
        case SET_GUIA_DESTINO:
            return action.recoleccion;
        case RESET_GUIA_NUEVA:
            return { ...initialRecoleccionState };
        default:
            return state;
    }
}

const initialGuiaMercancias: Mercancia[] = [new Mercancia({ ...initialMercancia })];

const initialGuiaMercanciasComplementarias: MercanciaDatosComplementarios[] = [];

export function guiaMercanciasReducer(state = initialGuiaMercancias, action: GuiaActionTypes): Mercancia[] {
    switch (action.type) {
        case SET_GUIA_MERCANCIAS:
            return action.mercancias;
        case RESET_GUIA_NUEVA:
            return [new Mercancia({ ...initialMercancia, id: 1 })];
        default:
            return state;
    }
}

export function guiaMercanciasComplementariasReducer(
    state = initialGuiaMercanciasComplementarias,
    action: GuiaActionTypes
): MercanciaDatosComplementarios[] {
    switch (action.type) {
        case SET_GUIA_MERCANCIAS_COMPLEMENTARIAS:
            return action.mercanciasComplementarias;
        case RESET_GUIA_NUEVA:
            return [];
        default:
            return state;
    }
}

const initialGuiaServicios: ServicioAdicional[] = [];

export function guiaServiciosReducer(state = initialGuiaServicios, action: GuiaActionTypes): ServicioAdicional[] {
    switch (action.type) {
        case SET_GUIA_SERVICIOS:
            return action.servicios;
        case RESET_GUIA_NUEVA:
            return [];
        default:
            return state;
    }
}

export function guiaConsultaReducer(state: IGuiaConsultaDto | null = null, action: GuiaActionTypes): IGuiaConsultaDto | null {
    switch (action.type) {
        case SET_GUIA_CONSULTA:
            return action.consulta;
        case CLEAR_GUIA_CONSULTA:
            return null;
        default:
            return state;
    }
}
